import { inject } from 'mobx-react';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import strings from '../../lang/strings'

class DropdownRegister extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.innerClick = this.innerClick.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.props.onRegister(6);
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  innerClick() {
    if (this.props.clickMethod && typeof this.props.clickMethod === 'function') {
      this.props.clickMethod()
    }
  }

  render() {
    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} className="f-b fs-15 chat-dropdown" >
        <DropdownToggle onClick={this.innerClick}>
          <div className='btn-data_reg cursor-point d-center'>
            <img className='star-img' src={'/assets/image/plus.png'} alt=''/>
            <div className='fs-15 sm-fs-14 f-sb ml-10'>{strings.bj_register}</div>
          </div>
        </DropdownToggle>
        {
          <DropdownMenu className="dropdown-menu dropdown-register-content cursor-point p-0" tag="ul">
            <div className={'ph-10'}>
              {/* <div className={'fs-15 pv-9 d-flex align-items-center chat-dropdown-item'} onClick={() => {this.toggle(); this.props.onRegister(0)}}><img className={'plus mr-5'} src={'/assets/image/plus.png'} alt=''/> {strings.proto_game_analyst_register}</div>
              <div className={'fs-15 pv-9 d-flex align-items-center chat-dropdown-item'} onClick={() => {this.toggle(); this.props.onRegister(1)}}><img className={'plus mr-5'} src={'/assets/image/plus.png'} alt=''/> {strings.proto_betting_register}</div>
              <div className={'fs-15 pv-9 d-flex align-items-center chat-dropdown-item'} onClick={() => {this.toggle(); this.props.onRegister(2)}}><img className={'plus mr-5'} src={'/assets/image/plus.png'} alt=''/> {strings.proto_victory_register}</div> */}
              {/* <div className={'fs-15 pv-9 d-flex align-items-center chat-dropdown-item'} onClick={() => {this.toggle(); this.props.onRegister(4)}}><img className={'plus mr-5'} src={'/assets/image/plus.png'} alt=''/> {strings.bj_pm_game}</div>
              <div className={'fs-15 pv-9 d-flex align-items-center chat-dropdown-item'} onClick={() => {this.toggle(); this.props.onRegister(5)}}><img className={'plus mr-5'} src={'/assets/image/plus.png'} alt=''/> {strings.bj_eve_game}</div> */}
              <div className={'fs-15 pv-9 d-flex align-items-center chat-dropdown-item'} onClick={() => {this.toggle(); this.props.onRegister(6)}}><img className={'plus mr-5'} src={'/assets/image/plus.png'} alt=''/> {strings.bj_game_article}</div>
              {/* <div className={'fs-15 pv-9 d-flex align-items-center chat-dropdown-item'} onClick={() => {this.toggle(); this.props.onRegister(3)}}><img className={'plus mr-5'} src={'/assets/image/plus.png'} alt=''/> {strings.daily_special_register}</div> */}
            </div>
          </DropdownMenu>
        }
      </Dropdown>
    );
  }
}

export default withRouter(inject('rootStore')(DropdownRegister));
